import axios from "axios";
import { getNodeServerUrl } from "../../utils/getNodeUrl";

/**
 * Get subdivisions by sales group code
 * @param {string} salesGroupCode - Sales Group Code
 * @returns {Promise} - Promise object with subdivision data
 */
export const getSubdivisionBySalesGroupApi = async (salesGroupCode) => {
  if (!salesGroupCode) {
    return {
      success: false,
      msg: "Sales Group Code is required",
    };
  }

  const nodeBaseUrl = getNodeServerUrl();

  const options = {
    url: `${nodeBaseUrl}/subdivision/${salesGroupCode}`,
    method: "get",
  };

  try {
    const response = await axios(options);

    if (response.status === 200 && response.data.success) {
      return {
        success: true,
        data: response.data.data,
        count: response.data.count,
      };
    } else {
      throw Error("Failed to fetch subdivisions");
    }
  } catch (err) {
    console.error("Error fetching subdivisions:", err);
    return {
      success: false,
      msg: err.response?.data?.msg || "Something went wrong while fetching subdivisions",
    };
  }
};

/**
 * Get all subdivisions
 * @returns {Promise} - Promise object with all subdivision data
 */
export const getAllSubdivisionsApi = async () => {
  const nodeBaseUrl = getNodeServerUrl();

  const options = {
    url: `${nodeBaseUrl}/subdivision/all`,
    method: "get",
  };

  try {
    const response = await axios(options);

    if (response.status === 200 && response.data.success) {
      return {
        success: true,
        data: response.data.data,
        count: response.data.count,
      };
    } else {
      throw Error("Failed to fetch subdivisions");
    }
  } catch (err) {
    console.error("Error fetching all subdivisions:", err);
    return {
      success: false,
      msg: err.response?.data?.msg || "Something went wrong while fetching subdivisions",
    };
  }
};
